import { render, staticRenderFns } from "./Manage_users.vue?vue&type=template&id=6d47e7da&"
import script from "./Manage_users.vue?vue&type=script&lang=js&"
export * from "./Manage_users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports